import * as React from 'react'
import { connect } from 'react-redux'
import { SiteCountry } from '../../data/models/locale'
import { AppState } from '../../data/state'
import { NotFound } from '../../pages/notfound'
import IpRedirector from './IpRedirector'

/** Component to redirect with country code in URL */
interface RTRProps {
  match: any
  location: any
  country: SiteCountry
}

const RedirectToCountryRoute: React.FC<RTRProps> = ({ match }) => {
  let to = ''
  const langs = Object.values(SiteCountry).join('|')

  if (match.params.path) {
    const parts = match.params.path.split('/').filter((i: string) => i !== '')
    const lastPart = parts.pop()

    if (lastPart.length === 5) {
      to += `/unlock/${lastPart}`
    } else if (lastPart.split('-').length >= 6) {
      to += `/trip/${lastPart}` // Probably a trip link
    } else if (/^\d{3}$/.test(lastPart)) {
      const url = parts.pop()
      to += `/trip/${url}/${lastPart}` // A trip link with code
    } else if (!new RegExp(`^(${langs})`).test(match.params.path)) {
      // Redirect to country
      to += `/${match.params.path}`
    } else {
      return <NotFound match={match} />
    }
  }

  return <IpRedirector path={to + location.search} />
}

const mapStateToProps = (state: AppState) => ({
  country: state.locale.country,
})

export default connect(mapStateToProps)(RedirectToCountryRoute)
